import React from "react";
var __jsx = React.createElement;
var StepTag = function StepTag(_ref) {
  var text = _ref.text,
    _onClick = _ref.onClick,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "bg-blue-lavender text-primary px-3 py-1 flex items-center justify-center rounded-full border border-solid border-primary cursor-pointer shrink-0 capitalize",
    onClick: function onClick() {
      return _onClick();
    }
  }, text));
};
export default StepTag;